import { useState } from "react";
import FormReservation from "./FormReservation";
import { useNavigate } from "react-router-dom";
import ModalBox from "../../ui/ModalBox";
import { Typography } from "@mui/material";

const AddReservation = () => {
  const [open, setOpen] = useState(false);

  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
    navigate(-1);
  };
  const handleSuccess = () => {
    setOpen(true);
  };
  return (
    <>
      <Typography variant="Poster" component="h4" gutterBottom>
        Add New Reservation
      </Typography>
      <FormReservation handleSuccess={handleSuccess} />
      <ModalBox
        open={open}
        handleClose={handleClose}
        text="The add operation has been completed successfully.. You added new Reservation"
        name="Reservation"
      />
    </>
  );
};

export default AddReservation;
